module.exports = __webpack_public_path__ + "img/risk_img1.f4cc21b9.png";